import getTransformAttributes from '@/screens/workflows/components/workflowInputVariablePane/lib/getTransformAttributes';
import { formatNestedAttributeKey } from '@shared/workflow/formatNestedAttributeKey.js';

const getFieldOptions = ({ actionId, appId, stepId, apps, steps }) => {
  if ((!stepId || !apps || !steps) && !actionId) {
    return null;
  }
  return getTransformAttributes({ actionId, appId, stepId, apps, steps })
    ?.map((n) => ({ label: formatNestedAttributeKey(n.key), value: n.key }))
    ?.filter((n) => !!n.value);
};

export default getFieldOptions;
